module.exports = __webpack_public_path__ + "img/collection-weddingRingsSecretHeart@2x.ac35b1e.webp";